import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export default class IncomeReport extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            systemModuleId: 8,
            moduleAccessStatus: 1,
            menuId: 227
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.refreshData();
            });
    }
    refreshData(e, outputFormat = "json") {
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/report/income", {
            outputFormat
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div className="container">
            <div className="center-block">
                <div className="row" style={{ "margin-bottom": "20px", "margin-top": "15px" }}>
                    <h4 className="txt-gray text-center txt-bold">صورت سود و زیان</h4>
                    <h5 className="text-muted text-center">{this.state.data.global.company.name}</h5>
                    {/*<div className="text-center">*/}
                    {/*    از*/}
                    {/*    <input autocomplete="off" id="fromRangeTxt" value="" className="range-from-example text-center" style={{ "border": "solid 1px #ccc" }} />*/}
                    {/*    تا*/}
                    {/*    <input autocomplete="off" id="toRangeTxt" value="" className="range-to-example text-center" style={{ "border": "solid 1px #ccc" }} />*/}
                    {/*    <a className="hand" onClick="getIncomeStateReport()"><i className="fa fa-search"></i></a>*/}
                    {/*</div>*/}
                </div>
                {/*<div className="mr-t-5 text-left">*/}
                {/*    <button className="btn btn-no-frame btn-smoke">*/}
                {/*        <span className="fa fa-print"></span>*/}
                {/*    </button>*/}
                {/*    <button className="btn btn-no-frame btn-smoke">*/}
                {/*        <span className="fa fa-file-pdf-o"></span>*/}
                {/*    </button>*/}
                {/*    <button className="btn btn-no-frame btn-smoke">*/}
                {/*        <span className="fa fa-file-excel-o"></span>*/}
                {/*    </button>*/}
                {/*</div>*/}

                <div className="balance-summary">
                    <div>
                        <span>درآمدها</span>
                        <span>
                            {this.money(this.state.data.revenue)}{' '}
                            {this.state.data.global.company.CurrencyUnit}
                        </span>
                    </div>

                    {this.state.data.incomeAccounts?.map((item, index) => (
                        <div key={index} className="detail-row">
                            <span>{item.title}</span>
                            <span>
                                {this.money(item.price)}{' '}
                                {this.state.data.global.company.CurrencyUnit}
                            </span>
                        </div>
                    ))}

                    <div>
                        <span>هزینه ها</span>
                        <span>
                            {this.money(this.state.data.expense)}{' '}
                            {this.state.data.global.company.CurrencyUnit}
                        </span>
                    </div>

                    {this.state.data.expenseAccounts?.map((item, index) => (
                        <div key={index} className="detail-row">
                            <span>{item.title}</span>
                            <span>
                                {this.money(item.price)}{' '}
                                {this.state.data.global.company.CurrencyUnit}
                            </span>
                        </div>
                    ))}

                    <div>
                        {this.state.data.netProfit >= 0 ? <span>سود خالص</span> : <span>زیان خالص</span>}
                        <span>
                            {this.money(this.state.data.netProfit)}{' '}
                            {this.state.data.global.company.CurrencyUnit}
                        </span>
                    </div>
                </div>

            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                this.renderForm(),
                <Footer />
            ];

        return contents;
    }
}